export enum StatusType {
  WAIT = 'WAIT',
  SALE = 'SALE',
  OUTOFSTOCK = 'OUTOFSTOCK',
  UNADMISSION = 'UNADMISSION',
  REJECTION = 'REJECTION',
  SUSPENSION = 'SUSPENSION',
  CLOSE = 'CLOSE',
  PROHIBITION = 'PROHIBITION',
  DELETE = 'DELETE',
}
